import translate from '../../translations'

export default data => {
  const str = `
        <div class="card__visual">
          <img src="${data.imgSrc}" alt="">
        </div>
        <div class="card__inner">
          <div class="card__top">
            <div class="card__heading">
              <span class="picto">
                  <svg class="icon icon--blue-light" aria-hidden="true">
                      <use href="#icon-calendar" xlink:href="#icon-calendar"></use>
                  </svg>
              </span>
              <span class="link link--medium link--blue-light">
                ${data.date}
              </span>
            </div>
            <div class="card__content">
              <a href="${data.url}">
                <h2 class="card__title">${data.title}</h2>
              </a>
              <div class="card__text">
                ${data.desc}
              </div>
            </div>
          </div>
            <div class="card__bottom">
              <a href="${
  data.url
}" class="link link--medium link--blue-light" rel="nofollow">
                 ${translate('SEE_EVENT')}
              </a>
            </div>
          </div>`

  return str
}
